import * as Schema from 'generated/graphql/schema';
import React from 'react';

import { DeviceContext } from '@/contexts/device';

export interface WithDevice {
  uuid: string;
  index?: string;
  peripheralId: string;
  owner: string | null;
  deviceType: Schema.SensorType;
  NodePicker: React.ReactNode;
  lineNodes: Schema.LineNode[];
  forceLoad: boolean;
  deviceLineId?: string;
}

export const withDevice = <A extends {}>(
  WrappedComponent: React.ComponentType<A & WithDevice>,
): React.ComponentType<A> => {
  return class WithDeviceWrapper extends React.PureComponent {
    public render() {
      return (
        <DeviceContext.Consumer>
          {({ owner, uuid, index, NodePicker, deviceType, lineNodes, deviceLineId }) => {
            return (
              <WrappedComponent
                forceLoad={false}
                owner={owner ?? null}
                uuid={uuid}
                index={index ? index.toString() : undefined}
                deviceType={deviceType as Schema.SensorType}
                peripheralId={`${uuid}-${index}`}
                NodePicker={NodePicker}
                lineNodes={lineNodes as Schema.LineNode[]}
                deviceLineId={deviceLineId}
                {...(this.props as unknown as A)}
              />
            );
          }}
        </DeviceContext.Consumer>
      );
    }
  } as unknown as React.ComponentType<A>;
};
